'use client';

import { useEffect } from 'react';
import { captureFbclid } from '@/util/meta_tracking_client';
import { useCookieConsent } from '@/components/hook/cookie-consent';

/**
 * Captures fbclid from URL parameters and stores as _fbc cookie.
 * Renders nothing — purely a side-effect component.
 */
export default function FbclidCapture() {
  const consent = useCookieConsent();

  useEffect(() => {
    if (consent.advertisement) {
      captureFbclid();
    }
  }, [consent.advertisement]);

  return null;
}
